﻿/**
 * API Integration Boundary Client
 * Connect Source Architecture
 * 
 * Provides centralized network boundary with error handling and request timeouts.
 */

import { ApiResponse } from './types';
import { appConfig } from '../config/env';

export class ApiClient {
  private readonly baseUrl: string;

  constructor(baseUrl: string = appConfig.apiBaseUrl) {
    this.baseUrl = baseUrl;
  }

  async post<TReq, TRes>(endpoint: string, body: TReq): Promise<ApiResponse<TRes>> {
    try {
      const response = await fetch(`${this.baseUrl}${endpoint}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      });

      if (!response.ok) {
        return {
          success: false,
          error: {
            code: `HTTP_${response.status}`,
            message: `API request failed with status ${response.status}`
          }
        };
      }

      const data = await response.json();
      return { success: true, data: data as TRes };
    } catch (err: unknown) {
      return {
        success: false,
        error: {
          code: 'NETWORK_ERROR',
          message: err instanceof Error ? err.message : 'Unknown communication error'
        }
      };
    }
  }
}

export const apiClient = new ApiClient();

